import React, { useState } from 'react';
import { GameSwitchWrapper, Label, StyledSwitch } from './GameSwitchStyles';

interface IProps {
  isPlaying: boolean;
  onChangeCallback: (checked: boolean, event: React.MouseEvent) => void | Promise<void>;
}

export const GameSwitch: React.FC<IProps> = (props) => {
  const { isPlaying, onChangeCallback } = props;
  const [isRequestPending, setIsRequestPending] = useState(false);

  const handleChange = async (checked: boolean, event: any) => {
    setIsRequestPending(true);
    try {
      await onChangeCallback(checked, event);
    } finally {
      setIsRequestPending(false);
    }
  };

  return (
    <GameSwitchWrapper data-test='warmup-toggle-button'>
      <Label active={!isPlaying}>Warmup</Label>
      <StyledSwitch
        checked={isPlaying}
        onChange={(checked: boolean, event: any) => handleChange(checked, event)}
        disabled={isRequestPending}
        checkedIcon={false}
        uncheckedIcon={false}
        offColor='#414141'
        onColor='#414141'
        width={51}
        height={31}
        handleDiameter={28}
        id='game-switcher'
      />
      <Label active={isPlaying}>Playing</Label>
    </GameSwitchWrapper>
  );
};
